import React from 'react'
import Badge from '../../../assets/Icons/Badge'
import BadgeGray from '../../../assets/Icons/BadgeGray'
import Email from '../../../assets/Icons/Email'
import Female from '../../../assets/Icons/Female'
import LineHeart from '../../../assets/Icons/LineHeart'
import Male from '../../../assets/Icons/Male'
import Phone from '../../../assets/Icons/Phone'
import BlueButton from '../Buttons/BlueButton'
import { t } from 'i18next'
import AwaImg from '../../../assets/images/AwaImg.png'
import { Link } from 'react-router-dom'
import { useContext } from 'react'
import Context from '../../../Store/Store'
import Verified from '../../../assets/Icons/Verified'
const DailyAnnouncement = (props) => {
     const { id, slug, img, userImage, name, badge, age, weight, location, type, price, gender, userId, oldPrice, phone, email } = props
     const ctx = useContext(Context);
     const itemIsFavorite = ctx.itemIsFavorite(id, slug);

     function toggleFavoriteStatusHandler() {
          console.log(id, slug)
          if (itemIsFavorite) {
               ctx.removeFavorite(id, slug);
          } else {
               ctx.addFavorite(id, slug)
          }
     }
     return (
          <div className={`AuctionCard mx-2 flex items-start justify-center min-h-[20rem] bg-white rounded-2xl pb-4 flex-col`}>
               <Link to={`/details/${slug}/${id}`} className="w-full">
                    <img src={img ? img : AwaImg} alt="" className='w-full object-cover rounded-2xl h-[25rem]' />
               </Link>
               <div className="w-full min-h-[10rem] max-h-[27rem]">
                    <div className="p-2 md:px-4 pt-4 flex items-center justify-between flex-wrap">
                         {(userImage || name || badge) &&
                              <>
                                   <Link to={`/user-page/${userId}`} className="user flex items-center gap-2">
                                        {userImage && <div className="userImage w-12 h-12 rounded-full relative overflow-hidden">
                                             <img src={userImage} alt="" className='h-full w-full object-cover' />
                                        </div>
                                        }
                                        {name && <div className="name">
                                             {name}
                                        </div>
                                        }
                                        <div className="flex items-center">
                                             {badge === 'gold' ?
                                                  <Badge />
                                                  :
                                                  <BadgeGray />
                                             }
                                             {props.is_verified === 1 && <div className=""><Verified /></div>}
                                        </div>
                                   </Link>

                                   <div className="no-wrap w-1/3 rtl:text-left ltr:text-right  ">
                                        {props.rate &&
                                             <span className="text-[1.5rem] text-yellow-500 ltr:ml-4 rtl:mr-4 flex items-center justify-end">
                                                  {/* ★ <b className="text-black/50 text-[1.5rem]">({props.rate})</b> */}
                                                  {props.rate === '1' && '★☆☆☆☆'}
                                                  {props.rate === '2' && '★★☆☆☆'}
                                                  {props.rate === '3' && '★★★☆☆'}
                                                  {props.rate === '4' && '★★★★☆'}
                                                  {props.rate === '5' && '★★★★★'}
                                                  {(props.rate === '0' || !props.rate) && '☆☆☆☆☆'}
                                             </span>}
                                   </div>
                              </>
                         }
                    </div>
                    <ul className='px-2 md:px-4'>
                         {type && <li className='mt-2 no-wrap'>Type: <b>{type}</b></li>}
                         {price && <li className='mt-2 no-wrap'>Price : <b>{price} {t('AED')}</b> {oldPrice && <span className='text-[1.2rem] text-red line-through'>{oldPrice}</span>} </li>}
                         <li className='w-full mt-2 flex items-center justify-start flex-wrap'>

                              <Link to={`/details/${slug}/${id}`} className="w-full">
                                   <p className='w-full flex items-center justify-start flex-wrap gap-2'>
                                        {gender && <span className='bg-blue w-12 h-12 rounded-full flex items-center justify-center'>{gender === 'male' ? <Male /> : <Female />}</span>}
                                        {age && <span className='bg-[#ececec] px-4 py-2 rounded-2xl text-[1.4rem]'>{age}</span>}
                                        {weight && <span className='bg-[#ececec] px-4 py-2 rounded-2xl text-[1.4rem]'>{weight}</span>}
                                   </p>
                              </Link>

                              {/* {(phone || email) &&
                                   <p className='flex items-center flex-wrap gap-1 w-2/6 justify-end'>
                                        {phone && <a href={`tel:${phone}`}> <Phone /> </a>}
                                        {email && <a href={`mailto:${email}`}> <Email /> </a>}
                                   </p>
                              } */}
                         </li>
                         <li className='flex items-center justify-between mt-4 gap-4 w-full'>
                              {(phone || email) &&
                                   <p className='flex items-center flex-wrap justify-start w-1/2 gap-4'>
                                        {phone && <a href={`tel:${phone}`}> <Phone /> </a>}
                                        {email && <a href={`mailto:${email}`}> <Email /> </a>}
                                   </p>
                              }
                              {/* <BlueButton className='border-2 border-blue flex items-center justify-center p-4 hover:bg-mint hover:border-mint w-full text-lg md:text-[1.6rem]'> Contact Owner </BlueButton> */}
                              <button className='' onClick={toggleFavoriteStatusHandler}> <LineHeart className={` hover:fill-blue ${itemIsFavorite ? 'fill-blue' : 'fill-[#d9d9d9]'}`} /> </button>
                         </li>

                    </ul>
               </div>
          </div>
     )
}

export default DailyAnnouncement